import React, { useEffect, useState } from "react";
import { AsyncSelect } from "@caelor/ui";
import { searchForBlogs } from "../../../api/confluence-api";
import { useTranslation } from "react-i18next";

export function htmlDecode(input) {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}

export const createProfileLink = (accountId) =>
  `${window.AP._hostOrigin}/wiki/plugins/servlet/ac/com.caelor.confluence.cloud.cosmos/caelor-cosmos-portal?ac.cosmosPage=profile&ac.accountId=${accountId}`;

export const localizeDate = (date, locale) => {
  return new Date(date).toLocaleDateString(locale, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const useAtlassianLocale = () => {
  const [locale, setLocale] = useState();

  useEffect(() => {
    if (window.AP) {
      window.AP?.user?.getLocale((loc) => setLocale(loc.replace("_", "-")));
    }
  }, [window.AP]);

  return [locale];
};

const mapBlogpost = (blogpost, locale) => ({
  contentId: blogpost.content.id,
  id: blogpost.content.id,
  type: blogpost.content.type,
  name: blogpost.content.title,
  space: { name: blogpost.content.space.name },
  excerpt: htmlDecode(blogpost.excerpt),
  labels: blogpost.content.metadata?.labels?.results.map((l) => l.label) ?? [],
  url: `${window.AP._hostOrigin}/wiki${blogpost.url}`,
  createdBy: blogpost.content.history.createdBy.displayName,
  avatarUrl: `${window.AP._hostOrigin}${blogpost.content.history.createdBy.profilePicture.path}`,
  lastModified: localizeDate(blogpost.lastModified, locale),
  label: blogpost.content.title,
  value: blogpost.content.id,
});

const BlogPicker = ({
  placeholder,
  selectedBlogs = [],
  onSelect = () => {},
}) => {
  const { t } = useTranslation();
  const [locale] = useAtlassianLocale();

  const loadOptions = async (query) => {
    return (await searchForBlogs(query)).results
      .map((blog) => mapBlogpost(blog, locale))
      .filter((blog) => {
        if (!selectedBlogs.length) return true;
        return !selectedBlogs.find((blogId) => blogId === blog.contentId);
      });
  };

  return (
    <AsyncSelect
      isSearchable
      value={[]}
      placeholder={placeholder || t("select-blog")}
      isClearable
      onChange={(option) => {
        onSelect(option);
      }}
      loadOptions={loadOptions}
    />
  );
};

export default BlogPicker;
